module.exports = __webpack_public_path__ + "img/baomingbeijing.7ecbb54c.png";